module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('h3', [_vm._v("Zone Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.zoneImage,
      "width": "200",
      "height": "150"
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Upload new Image"
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitFile
    }
  }, [_vm._v("Save Image")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296985b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ZoneInfo.vue
// module id = 1392
// module chunks = 1